(() => {
  const home = document.querySelector('[data-heir-home]');
  if (!home || window.__heirHomeAnalyticsV1 || window.Shopify?.designMode) return;
  window.__heirHomeAnalyticsV1 = true;

  const selector = 'a[href],button,[role="button"],summary,input[type="submit"]';
  const indices = new WeakMap();
  const counts = Object.create(null);
  const formSubmitClicks = new WeakMap();
  const knownRoutes = new Map([
    ['/', 'home'],
    ['/collections/in-stock-ready-to-ship', 'ready_to_ship'],
    ['/collections/production', 'modern_heir'],
    ['/collections/the-studio-edit', 'studio_edit'],
    ['/collections/vintage', 'vintage'],
    ['/collections/modern', 'modern'],
    ['/collections/heir-studio', 'heir_studio'],
    ['/pages/trade-home-page', 'trade_program'],
    ['/pages/trade', 'trade_access'],
    ['/pages/create-trade-account', 'trade_application'],
    ['/pages/request-for-quote', 'quote_request'],
    ['/pages/contact-us', 'contact'],
    ['/blogs/blog', 'journal'],
    ['/account', 'account'],
    ['/cart', 'cart'],
    ['/search', 'search']
  ]);

  const inHomeSection = (control, selector) => home.contains(control) && !!control.closest(selector);
  const sectionFor = control => {
    if (inHomeSection(control, '.heir-html__hero')) return 'hero';
    if (inHomeSection(control, '.heir-html__categories')) return 'categories';
    if (inHomeSection(control, '.heir-html__guidance')) return 'guidance';
    if (inHomeSection(control, '.heir-html__film')) return 'film';
    if (inHomeSection(control, '.heir-html__studio')) return 'studio';
    if (control.closest('[class*="mobile"],[id*="mobile"]') && control.closest('#header,theme-header,header,nav,[class*="menu"]')) return 'mobile_nav';
    if (control.closest('#header,theme-header,header,nav')) return 'header';
    if (control.closest('footer,[class*="footer"]')) return 'footer';
    if (control.closest('dialog,[role="dialog"],[class*="modal"],[class*="drawer"]')) return 'overlay';
    if (control.closest('[id*="chat"],[class*="chat"],[id*="float"],[class*="float"]')) return 'floating';
    try {
      if (window.getComputedStyle(control).position === 'fixed') return 'floating';
    } catch (_) {}
    return 'content';
  };

  const formRole = form => {
    const id = (form?.id || '').toLowerCase();
    const classes = (typeof form?.className === 'string' ? form.className : '').toLowerCase();
    if (id === 'heir-guidance-form') return 'guidance';
    if (/newsletter|email-signup/.test(id + ' ' + classes)) return 'newsletter';
    if (form?.querySelector('input[type="search"]')) return 'site_search';
    return 'other';
  };

  const destinationGroup = control => {
    const anchor = control.closest('a[href]');
    if (!anchor) return 'none';
    try {
      const url = new URL(anchor.getAttribute('href'), window.location.origin);
      if (!['http:', 'https:'].includes(url.protocol)) return 'other';
      if (url.origin !== window.location.origin) return 'external';
      const path = url.pathname.replace(/\/+$/, '') || '/';
      if (knownRoutes.has(path)) return knownRoutes.get(path);
      if (/^\/collections\/[^/]+\/?$/i.test(path)) return 'collection';
      if (/^\/products\/[^/]+\/?$/i.test(path)) return 'product';
      if (/^\/pages\/[^/]+\/?$/i.test(path)) return 'page';
      if (/^\/blogs\/[^/]+\/?$/i.test(path)) return 'blog';
      if (/^\/policies\/[^/]+\/?$/i.test(path)) return 'policy';
      return 'other';
    } catch (_) {
      return 'other';
    }
  };

  const assignIndex = control => {
    if (indices.has(control)) return indices.get(control);
    const section = sectionFor(control);
    counts[section] = (counts[section] || 0) + 1;
    const id = section + '_control_' + counts[section];
    indices.set(control, id);
    return id;
  };

  const initializeIndices = () => {
    document.querySelectorAll(selector).forEach(assignIndex);
  };

  const allowed = () => {
    try {
      const privacy = window.Shopify?.customerPrivacy;
      // Shopify's allowed method already applies merchant settings, visitor
      // location, and any consent choice. An empty currentVisitorConsent()
      // value means no explicit choice; it is not a denial in regions where
      // Shopify permits analytics by default.
      return privacy?.analyticsProcessingAllowed() === true;
    } catch (_) {
      return false;
    }
  };

  const emit = fields => {
    if (!allowed() || document.visibilityState === 'hidden') return;
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      event: 'heir_home_interaction',
      event_version: '1',
      page_type: 'home',
      ...fields
    });
  };

  const formSubmit = control => {
    const form = control.closest('form');
    return !!form && (control.matches('input[type="submit"],button[type="submit"],button:not([type])'));
  };

  const interactionType = control => {
    if (formSubmit(control)) return 'form_submit';
    if (control.tagName === 'SUMMARY') return 'disclosure';
    if (control.tagName === 'A') return 'link';
    if (control.hasAttribute('data-heir-next') || control.hasAttribute('data-heir-previous') ||
        control.hasAttribute('data-heir-goto')) return 'carousel_control';
    if (control.hasAttribute('data-heir-video-toggle')) return 'video_control';
    return 'button';
  };

  const staticControlId = (control, section, destination) => {
    if (formSubmit(control)) return formRole(control.closest('form')) + '_submit';
    if (control.hasAttribute('data-heir-next')) return 'hero_next';
    if (control.hasAttribute('data-heir-previous')) return 'hero_previous';
    if (control.hasAttribute('data-heir-goto')) return 'hero_slide_select';
    if (control.hasAttribute('data-heir-video-toggle')) return 'film_play_pause';
    if (destination !== 'none') return section + '_' + destination;
    const label = (control.getAttribute('aria-label') || '').toLowerCase();
    if (/^chat$/.test(label)) return 'chat_toggle';
    if (/^(close|close dialog|close menu|close search)$/.test(label)) return 'overlay_close';
    if (/^play background film$|^pause background film$/.test(label)) return 'film_play_pause';
    return assignIndex(control);
  };

  const getControl = event => {
    const path = typeof event.composedPath === 'function' ? event.composedPath() : [event.target];
    return path.find(node => node instanceof Element && node.matches(selector)) || null;
  };

  const track = (control, type) => {
    if (!control || control.closest('#shopify-preview-bar,[data-shopify-preview-bar]')) return;
    const section = sectionFor(control);
    const destination = destinationGroup(control);
    const form = control.closest('form');
    const isSubmit = formSubmit(control);
    const index = staticControlId(control, section, destination);
    const navigationSurface = section === 'mobile_nav' ||
      (section === 'header' && window.matchMedia('(max-width: 767px)').matches) ? 'mobile' :
      (section === 'header' ? 'desktop' : 'content');

    emit({
      section_id: section,
      control_id: index,
      control_type: control.tagName.toLowerCase() === 'input' ? 'submit' : control.tagName.toLowerCase(),
      interaction_type: type,
      destination_group: isSubmit ? 'none' : destination,
      navigation_surface: navigationSurface
    });

    if (isSubmit && form) formSubmitClicks.set(form, Date.now());
  };

  initializeIndices();

  document.addEventListener('click', event => {
    if (!event.isTrusted) return;
    const control = getControl(event);
    if (!control) return;
    track(control, interactionType(control));
  }, {capture: true, passive: true});

  document.addEventListener('submit', event => {
    if (!event.isTrusted || !(event.target instanceof HTMLFormElement)) return;
    const form = event.target;
    const lastClick = formSubmitClicks.get(form) || 0;
    if (Date.now() - lastClick < 1200) return;
    const section = sectionFor(form);
    emit({
      section_id: section,
      control_id: formRole(form) + '_submit',
      control_type: 'form',
      interaction_type: 'form_submit',
      destination_group: 'none',
      navigation_surface: section === 'mobile_nav' ? 'mobile' : 'content'
    });
  }, {capture: true});

  const sync = () => { active = allowed(); };
  let active = false;
  document.addEventListener('visitorConsentCollected', sync);
  window.addEventListener('pageshow', sync);
  if (window.Shopify?.customerPrivacy) {
    sync();
  } else if (typeof window.Shopify?.loadFeatures === 'function') {
    window.Shopify.loadFeatures([{name: 'consent-tracking-api', version: '0.1'}], error => {
      if (!error) sync();
    });
  }
})();
